// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Vu7h0","fullView":"styles_fullView__2Iw9k"};